<template>
    <div class="header-mobile-menu-button" @click="toggleMenu()" v-if="button_location === 'header'">
        <div class="icon">
            <i class="fa fa-bars"></i>
        </div>
        <strong>Menu</strong>
    </div>
    <div class="sidebar-mobile-menu-button" @click="toggleMenu()" v-else>
        <i class="fal fa-times"></i>
    </div>
</template>

<script>
  export default {
    props: [
      'button_location',
    ],
    methods: {
      toggleMenu() {
        const sidebar = document.getElementById('main_sidebar_menu');
        if(sidebar.classList.contains('_open')) {
          document.getElementById('main_sidebar_menu').classList.remove('_open');
          document.getElementById('body').classList.remove('main-sidebar-open');
        } else {
          document.getElementById('main_sidebar_menu').classList.add('_open');
          document.getElementById('body').classList.add('main-sidebar-open');
        }
      }
    },
  };
</script>
